import { EEnterpriseStatus } from '@/types/enterpriseService';

// 未开通服务状态
export const noCertStatus = [
  EEnterpriseStatus.NOT_JOIN,
  EEnterpriseStatus.NOT_CERT,
  EEnterpriseStatus.UNDER_REVIEW,
  EEnterpriseStatus.NOT_PASS,
];
